import {getState, patchState, signalStore, withHooks, withMethods, withState} from "@ngrx/signals";
import {Settings} from "@core/types";
import {effect} from "@angular/core";
import { EncryptionService } from '@shared/services';
import { STORE } from "@core/constans";
import {Tab} from '@shared/types';
const encryptionService = new EncryptionService();

type SettingState = {
  data: Settings;
};

const initialState: SettingState = {
  data: {
    darkMode: false,
    rememberMe: false,
    lastLogin: '',
    activeMenu: '',
    miniMenu: false,
    language:'es',
    openTabsByContext: {},
    activeTabIndexByContext: {}
  }
};

function persistenceState(): SettingState {
  const version = localStorage.getItem(`${STORE.settings}_ver`);


  if (version !== STORE.settings_version) {
    localStorage.removeItem(STORE.settings);
    localStorage.setItem(`${STORE.settings}_ver`,STORE.settings_version);
  }
  const savedState = localStorage.getItem(STORE.settings);
  if (savedState) {
    try {
      const parsed = encryptionService.decryptJson(savedState) as SettingState | null;
      const safeState: SettingState = parsed?.data ? parsed : initialState;

      const dataAny = safeState.data as any;
      const openTabsByContext: Record<string, Tab[]> = dataAny.openTabsByContext ?? {};
      const activeTabIndexByContext: Record<string, number> = dataAny.activeTabIndexByContext ?? {};

      return {
        data: {
          ...safeState.data,
          openTabsByContext,
          activeTabIndexByContext,
        },
      };
    } catch {
      return initialState;
    }
  }
  return initialState;
}

function saveState(state: SettingState) {
  const encrypted = encryptionService.encryptJson(state);
  localStorage.setItem(STORE.settings, encrypted);
  localStorage.setItem(`${STORE.settings}_ver`,STORE.settings_version);
}



export const settingStore =  signalStore(


  { providedIn: 'root'},
  withState(persistenceState()),
  withMethods((store) => ({
    changeViewMode(darkMode: boolean) {
      patchState(store, (state) => ({
        data: {
          ...state.data,
          darkMode: darkMode
        }
      }));
    },

    setLanguage(lang: string) {
      patchState(store, (state) => ({
        data: {
          ...state.data,
           language: lang
        }
      }));
    },



    setMiniMenu(miniMenu: boolean) {
      patchState(store, (state) => ({
        data: {
          ...state.data,
           miniMenu: miniMenu
        }
      }));
    },

    toggleMenu(name:string) {
        let temp = store.data.activeMenu();

      patchState(store, (state) => ({
        data: {
          ...state.data,
          activeMenu: name == temp ? "" : name
        }
      }));

    },
    setOpenTabsForContext(contextKey: string, tabs: Tab[]) {
      patchState(store, (state) => ({
        data: {
          ...state.data,
          openTabsByContext: {
            ...state.data.openTabsByContext,
            [contextKey]: tabs
          }
        }
      }));
    },

    setActiveTabIndexForContext(contextKey: string, index: number) {
      patchState(store, (state) => ({
        data: {
          ...state.data,
          activeTabIndexByContext: {
            ...state.data.activeTabIndexByContext,
            [contextKey]: index
          }
        }
      }));
    },
    // isActiveMenu(name: string) {
    //   //return setting.activeMenu().includes(name);
    //   return setting.activeMenu() == name;
    // },

    rememberLogin(user: string, rememberMe: boolean) {
      patchState(store, (state) => {
        return ({
          data: {
            ...state.data,
            lastLogin: user,
            rememberMe: rememberMe
          }
        });
      });
    }
  })),
  withHooks({
    onInit(store) {
      effect(() => {
        const state = getState(store);
        saveState(state);
        // document.body.className = store.setting.darkMode() ?
        //   'dark-mode-variables' : '';

      });
    },
  })
)

